package ui.external.materialui

data class SnackbarAnchorOrigin(
    var vertical: String? = undefined,
    var horizontal: String? = undefined
)
